import axios from 'axios';

import Store from '../store';
import { getAPI } from './apiEndpointHelpers';
import handleLogout from './handleLogout';

export type MethodType =
  | 'get'
  | 'post'
  | 'delete'
  | 'patch'
  | 'put'
  | 'head'
  | 'options';

export type ConfigType = {
  url: string;
  method: MethodType;
  data?: any;
  params?: {
    page?: number;
    limit?: number;
    [key: string]: any;
  };
  config?: {
    store: {
      action: 'set' | 'update' | 'reset' | 'remove' | 'resetRedux';
      key: string;
    };
  };
};

const requestAPI = async (config: ConfigType, isDebug = false) => {
  const API_URL = getAPI();
  const redux = config?.config;
  try {
    if (redux?.store?.key) {
      Store.store.dispatch(
        Store.Actions.update('loading', { [redux.store.key]: true }),
      );
      setTimeout(() => {
        Store.store.dispatch(
          Store.Actions.update('loading', { [redux.store.key]: false }),
        );
      }, 20000);
    }

    const res = await axios({
      ...config,
      url: API_URL + config.url,
    });

    if (
      res.status === 401 &&
      res.data.message === 'Your token has expired! Please log in again!!'
    ) {
      handleLogout();
      throw new Error('Token expired');
    }

    if (res.status >= 200 && res.status < 300) {
      const data = res?.data?.data || res?.data || res;

      if (config?.config?.store && redux) {
        Store.store.dispatch(
          Store.Actions[redux.store.action](redux.store.key, data),
        );
      }
      if (res.data.status === 'error') {
        throw res.data;
      } else {
        return data;
      }
    }
  } catch (err: any) {
    try {
      if (
        err.response.data.message ===
        'Your token has expired! Please log in again!!'
      ) {
        handleLogout();
      }
    } catch (error) {
      console.error(error);
    }
    try {
      if (isDebug) {
        console.error(err.response.data);
      }
    } catch (error) {
      console.error(error);
    }
    if (err && err.response && err.response.data && err.response.data.message) {
      throw err.response.data.message;
    }
    if (err && err.response && err.response.data && err.response.data.error) {
      throw err.response.data.error;
    }
    throw err.message || err;
  } finally {
    if (redux?.store?.key) {
      Store.store.dispatch(
        Store.Actions.update('loading', { [redux.store.key]: false }),
      );
    }
  }
};

export default requestAPI;
